import React from 'react';
import PageContainerAuth from '../../components/common/PageContainerAuth';
import DocumentEditSection from '../../components/pages/documents/edit/DocumentEditSection';

export default function DocumentEdit() {
    return (
        <PageContainerAuth section="mailings-attachs-add" pageTitle="Modifier la Pièce jointe">
            <DocumentEditSection/>
        </PageContainerAuth>
    );
}